module.exports = __webpack_public_path__ + "img/tabicon_0.fcc6d61e.png";